import { useState } from "react";

export const ORG_NOTE_MAX_LENGTH = 5000;

export interface OrgNoteDraft {
  note: string;
  setNote: (note: string) => void;
  saveNote: () => void;
  handleOpenChange: (open: boolean) => void;
}

/**
 * Editable copy of an org note. The draft resets to the saved note each time
 * the editor opens, so abandoned edits do not reappear on the next open.
 */
export function useOrgNoteDraft({
  orgNote,
  onOpenChange,
  onSave,
}: {
  orgNote: string | null;
  onOpenChange: (open: boolean) => void;
  onSave: (orgNote: string | null) => void;
}): OrgNoteDraft {
  const [note, setNote] = useState(orgNote ?? "");

  const saveNote = () => {
    const trimmedNote = note.trim();
    setNote(trimmedNote);
    onSave(trimmedNote || null);
  };

  const handleOpenChange = (nextOpen: boolean) => {
    if (nextOpen) {
      setNote(orgNote ?? "");
    }
    onOpenChange(nextOpen);
  };

  return { note, setNote, saveNote, handleOpenChange };
}
